// components/ui/SiteBanner.jsx
export default function SiteBanner() {
  return (
    <div className="fixed bottom-4 left-4 z-[9999] max-w-sm rounded-2xl border border-white/10 bg-espresso/90 backdrop-blur-xl shadow-2xl px-4 py-3 text-warm-alabaster">
      <div className="flex items-start gap-3">
        <div className="relative mt-1 flex h-3 w-3 flex-shrink-0">
          <span className="absolute inline-flex h-3 w-3 rounded-full bg-latte-gold opacity-75 animate-ping" />
          <span className="relative inline-flex h-3 w-3 rounded-full bg-latte-gold" />
        </div>

        <div className="space-y-1">
          <p className="text-sm font-semibold text-latte-gold">
            Site en cours de finalisation
          </p>
          <p className="text-xs leading-relaxed text-warm-alabaster/80">
            💳 Paiements en ligne bientôt disponibles.
          </p>
          <p className="text-xs leading-relaxed text-warm-alabaster/80">
            🆕 Nouveaux produits à venir !
          </p>
        </div>
      </div>
    </div>
  );
}